import { render, staticRenderFns } from "./brands.vue?vue&type=template&id=87468652&"
import script from "./brands.vue?vue&type=script&lang=js&"
export * from "./brands.vue?vue&type=script&lang=js&"
import style0 from "./brands.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports